<template>
    <Modal>
        <template #title>Registration</template>

        <form id="form" @submit.prevent="formSubmit">
            <div class="form-field">
                <label class="form-field-label">Full name</label>
                <input type="text" name="name" v-model.trim="userName"/>
                <small v-if="errorUserName" class="error-text">{{ errorUserName }}</small>
            </div>

            <div class="form-field">
                <label class="form-field-label">E-mail</label>
                <input type="text" name="email" v-model.trim="email"/>
                <small v-if="errorEmail" class="error-text">{{ errorEmail }}</small>
            </div>

            <div class="form-field">
                <label class="form-field-label">Password</label>
                <input type="password" name="password" v-model.trim="password"/>
                <small v-if="errorPassword" class="error-text">{{ errorPassword }}</small>
            </div>
        </form>

        <p>
            <span class="link float-right" @click="forgotPassword">Forgot password?</span>

            Already have an account?
            <span class="link" @click="openSignIn">Sign In</span>
        </p>

        <template #footer>
            <Button class="gray" @click="closeModal">Cancel</Button>

            <Button type="submit" form="form" :loading="sendStatus">Sign Up</Button>
        </template>
    </Modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import Modal from "../../components/Modal";
    import Button from "../../components/Button";
    
    export default {
        name: "UserRegistrationModal",
        
        components: {
            Button,
            Modal,
        },

        emits: [
            'openSignIn',
            'forgotPassword',
        ],

        data() {
            return {
                sendStatus: false,

                userName: '',
                email: '',
                password: '',

                errorUserName: false,
                errorEmail: false,
                errorPassword: false,
            }
        },

        methods: {
            ...mapActions('authentication', [
                'registration',
            ]),

            closeModal() {
                this.$emit('closeModal');
            },

            resetErrors() {
                this.errorUserName = false;
                this.errorEmail = false;
                this.errorPassword = false;
            },

            async formSubmit() {
                this.sendStatus = true;

                this.resetErrors();

                let formData = {
                    userName: this.userName,
                    email: this.email,
                    password: this.password,
                    role: 'user'
                };

                this.registration(formData)
                    .then(() => {
                        // registration is success
                        this.closeModal();
                    })
                    .catch(err => {
                        // backend validation errors
                        this.errorUserName = err['userName'];
                        this.errorEmail = err['email'];
                        this.errorPassword = err['password'];
                    })
                    .finally(() => {
                        this.sendStatus = false;
                    });
            },

            openSignIn() {
                this.$emit('openSignIn');
            },

            forgotPassword() {
                this.$emit('forgotPassword');
            },

        },

    }
</script>

<style scoped>

</style>